<template>
  <div>
    <!-- for Modal Window Start -->
    <div style="width:50%">
    <modal 
      name="modalview" 
      height="auto" 
      width="100%"
      :resizable="false"
      :adaptive="false"
      :scrollable="true">
      <div class="modal-header">
      </div>
        <div class="modal-body" style="text-align:center;">
          <div class="btn-pagenav">
            <button 
                v-on:click="closePreview" 
                class="btn-closepreview">入力画面に戻る</button>
            <button v-if="checkPreviewFlag==true"
                v-on:click="submit" 
                class="btn-send">送信</button>
          <br />
          <Preview :val="mydata" ref="Preview" />
          <br />
            <button 
                v-on:click="closePreview" 
                class="btn-closepreview">入力画面に戻る</button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;;&nbsp;
            <button v-if="checkPreviewFlag==true"
                v-on:click="submit" 
                class="btn-send">送信</button>
          </div>
        </div>  
    </modal>
    </div>
    <!-- for Modal Window End -->
    <!-- Content Start -->
    <div style="width:100%;">
      <!-- Navi Start -->
      <div class="gnav-wrap">
        <div class="gnav">
          <div :class="navigationCss(1)"><span class="nav-number">①</span><span class="nav-contents">氏名・生年月日</span></div>
          <div :class="navigationCss(2)"><span class="nav-number">②</span><span class="nav-contents">住所・連絡先</span></div>
          <div :class="navigationCss(3)"><span class="nav-number">③</span><span class="nav-contents">学歴・職歴</span></div>
          <div :class="navigationCss(4)"><span class="nav-number">④</span><span class="nav-contents">免許・資格</span></div>
          <div :class="navigationCss(5)"><span class="nav-number">⑤</span><span class="nav-contents">志望動機</span></div>
          <div :class="navigationCss(6)"><span class="nav-number">⑥</span><span class="nav-contents">本人希望欄</span></div>
          <div :class="navigationCss(7)"><span class="nav-number">⑦</span><span class="nav-contents">証明写真</span></div>
        </div>
      </div>
      <!-- Navi End -->
      <!-- Content Page 1 Start -->
      <div class="contents-form" v-if="page==1">
        <h1>①氏名・生年月日</h1>
          プロフィールを入力してください。
        <!-- Content Information Start -->
        <div class="contents-explain">
          <div v-for="error in errors" :key="error">
            <span style="color:red;font-weight:bold;">{{error}}</span>
          </div>
        </div>
        <!-- Content Information End -->
        <label>氏名：</label>
        <div class="form-group" style="display: flex;">
          <span class="form-leftlabel">姓</span><input class="form-control" type="text" v-model="indata.fname" required="required">
          <span class="form-leftlabel">名</span><input class="form-control" type="text" v-model="indata.lname" required="required">
        </div>
        <label>ふりがな：</label>
        <div class="form-group" style="display: flex;">
          <span class="form-leftlabel">せい</span><input class="form-control" type="text" v-model="indata.fnamekana" required="required">
          <span class="form-leftlabel">めい</span><input class="form-control" type="text" v-model="indata.lnamekana" required="required">
        </div>
        <label>性別：</label>
        <div class="form-group" style="display: flex;">
          <input class="form-control" type="radio" value="男" v-model="indata.sex"><span class="form-addlabel">男</span>
          <input class="form-control" type="radio" value="女" v-model="indata.sex"><span class="form-addlabel">女</span>
        </div>
        <label>生年月日：</label>
        <div class="form-group" style="display: flex;">
            <select class="form-control" v-model="indata.birthdayyear" @change="calcAge">
              <option v-for="w in dateyears" :key="w.id">{{w.label}}</option>
            </select><span class="form-addlabel">年</span>
            <select class="form-control" v-model="indata.birthdaymonth" @change="calcAge">
              <option v-for="w in datemonths" :key="w.id">{{w.label}}</option>
            </select><span class="form-addlabel">月</span>
            <select class="form-control" v-model="indata.birthdayday" @change="calcAge">
              <option v-for="w in datedays" :key="w.id">{{w.label}}</option>
            </select><span class="form-addlabel">日</span>
        </div>
        <div class="form-group" style="display: flex;">
            <input class="form-control" type="number" style="text-align:right;width:70px;" v-model="indata.age" readonly><span class="form-addlabel">歳</span>
        </div>
        <label>扶養家族(配偶者を除く)：</label>

        <div class="form-group" style="display: flex;">
          <input class="form-control" type="number" v-model="indata.huyonin" style="width:100px;" min="0" max="9"><span class="form-addlabel">人</span>
        </div>
        <label>配偶者：</label>
        <div class="form-group" style="display: flex;">
          <input class="form-control" type="radio" value="有" v-model="indata.haigusyaumu"><span class="form-addlabel">有</span>
          <input class="form-control" type="radio" value="無" v-model="indata.haigusyaumu"><span class="form-addlabel">無</span>
        </div>
        <label>配偶者の扶養義務：<br />
        <span class="subdoc">※扶養家族とは、自分の収入で養っている家族のことを言います。</span> 
        </label>
        <div class="form-group" style="display: flex;">
          <input class="form-control" type="radio" value="有" v-model="indata.haigusyahuyogimu"><span class="form-addlabel">有</span>
          <input class="form-control" type="radio" value="無" v-model="indata.haigusyahuyogimu"><span class="form-addlabel">無</span>
        </div>
        <label>通勤時間：<br />
        <span class="subdoc">※通勤時間とは、自宅から会社までにかかる片道の所要時間のことです。徒歩、自転車、車、公共交通機関など、通勤にかかるすべての時間を合計した時間です。自宅を出たところから、勤務地に入るまでの時間を選択してください。</span>          
        </label>
        <div class="form-group" style="display: flex;">
            <select class="form-control" v-model="indata.tukintimehour">
              <option v-for="w in timehours" :key="w.id">{{w.label}}</option>
            </select><span class="form-addlabel">時間</span>
            <select class="form-control" v-model="indata.tukintimeminute">
              <option v-for="w in timeminutes" :key="w.id">{{w.label}}</option>
            </select><span class="form-addlabel">分</span>
        </div>
        <div class="btn-pagenav">
          <button 
              v-on:click="openPreview" 
              class="btn-preview">プレビュー</button>
        </div>
      </div>
      <div class="contents-form" v-if="page==2">
        <h1>②住所・連絡先</h1>
        <span class="titledoc">住所と連絡先を入力してください。<br />
          建物名や部屋番号は略さず入力しましょう。ふりがなの番地などの数字は入力不要です。<br />
          連絡先は連絡が付きやすい番号。メールアドレスをご記入ください。<br />
        </span>
        <!-- Content Information Start -->
        <div class="contents-explain">
          <div v-for="error in errors" :key="error">
            <span style="color:red;font-weight:bold;">{{error}}</span>
          </div>
        </div>
        <!-- Content Information End -->
        <h2 class="subtitle">■現住所</h2>
        <label>郵便番号：</label>
        <div class="form-group" style="display: flex;">
            <input class="form-control" type="text" v-model="indata.gen.zipcode">
        </div>
        <label>住所：</label><br />
        <div class="form-group" style="display: flex;">
          <input class="form-control" type="hidden" v-model="indata.gen.prefname">
          <input class="form-control" type="text" style="width:100%;" v-model="indata.gen.address">
        </div>
        <span class="sublabel"> 建物名(任意)</span>
        <div class="form-group" style="display: flex;">
          <input class="form-control" type="text" style="width:100%;" v-model="indata.gen.address2">
        </div>
        <label>ふりがな：</label>
        <div class="form-group" style="display: flex;">
          <input class="form-control" type="hidden" v-model="indata.gen.prefnamekana">
          <input class="form-control" type="text" style="width:100%;" v-model="indata.gen.addresskana">
        </div>
        <span class="sublabel"> 建物名(任意)</span>
        <div class="form-group" style="display: flex;">
          <input class="form-control" type="text" style="width:100%;" v-model="indata.gen.addresskana2">
        </div>
        <label>電話番号：</label>
        <div class="form-group" style="display: flex;">
            <input class="form-control" type="tel" v-model="indata.gen.tel">
        </div>
        <label>メールアドレス：</label>
        <div class="form-group" style="display: flex;">
            <input class="form-control" type="email" v-model="indata.gen.email">
        </div>
        <div class="form-group" >
          <br />
        </div>
        <label  class="acd-label" for="acd-check1">■その他の連絡先</label>
        <span class="subdoc">※現住所と連絡先が異なる場合のみご記入ください</span>
        <input id="acd-check1" class="acd-check" type="checkbox">
        <div class="acd-content">
        <label>郵便番号：</label>
        <div class="form-group" style="display: flex;">
            <input class="form-control" type="text" v-model="indata.renraku.zipcode">
        </div>
        <label>住所：</label>
        <div class="form-group" style="display: flex;">
            <input class="form-control" type="hidden"  v-model="indata.renraku.prefname">
            <input class="form-control" type="text" style="width:100%;" v-model="indata.renraku.address">
        </div>
        <span class="sublabel"> 建物名(任意)</span>
        <div class="form-group" style="display: flex;">
          <input class="form-control" type="text" style="width:100%;" v-model="indata.renraku.address2">
        </div>
        <label>ふりがな：</label>
        <div class="form-group" style="display: flex;">
          <input class="form-control" type="hidden" v-model="indata.renraku.prefnamekana">
          <input class="form-control" type="text" style="width:100%;" v-model="indata.renraku.addresskana">
        </div>
        <span class="sublabel"> 建物名(任意)</span>
        <div class="form-group" style="display: flex;">
          <input class="form-control" type="text" style="width:100%;" v-model="indata.renraku.addresskana2">
        </div>
        <label>電話番号：</label>
        <div class="form-group" style="display: flex;">
            <input class="form-control" type="tel" v-model="indata.renraku.tel">
        </div>
        <label>メールアドレス：</label>
        <div class="form-group" style="display: flex;">
            <input class="form-control" type="email" v-model="indata.renraku.email">
        </div>
        </div>
        <div class="btn-pagenav">
          <button 
              v-on:click="openPreview" 
              class="btn-preview">プレビュー</button>
        </div>
      </div>
      <div class="contents-form" v-if="page==3">
        <h1>③学歴・職歴</h1>
          ※義務教育以降の高校、専門学校などから記入してください。学校名は、略さず正式名称で記入し、「高校」ではなく「高等学校」と書いてください。
        <!-- Content Information Start -->
        <div class="contents-explain" style="padding-top:0;padding-bottom:0;">
          <div v-for="error in errors" :key="error">
            <span style="color:red;font-weight:bold;">{{error}}</span>
          </div>
        </div>
        <!-- Content Information End -->
          <table style="width:100%;border-spacing: 0px 5px;font-size:0.8em;">
            <thead>
            <tr>
              <th><label>(西暦)：</label></th>
              <th></th>
              <th></th>
              <th></th>
              <th><label>学歴・職歴：</label></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="gakusyoku in indata.gakusyokus" :key="gakusyoku.id">
              <td style="width:80px;vertical-align:top;">
                <select class="form-control" v-model="gakusyoku.year">
                  <option v-for="w in dateyears" :key="w.id">{{w.label}}</option>
                </select>
              </td>
              <td style="width:20px;">
                <span>&nbsp;年</span>
              </td>
              <td style="width:60px;vertical-align:top;">
                <select class="form-control" v-model="gakusyoku.month">
                  <option v-for="w in datemonths" :key="w.id">{{w.label}}</option>
                </select>
              </td>
              <td style="width:20px;">
                <span>&nbsp;月</span>
              </td>
              <td>
                <input class="form-control" type="text" v-model="gakusyoku.content" style="width:100%;">
              </td>
            </tr>
            </tbody>
          </table>
        <div class="btn-pagenav">
          <button 
              v-on:click="openPreview" 
              class="btn-preview">プレビュー</button>
        </div>
      </div>
      <div class="contents-form" v-if="page==4">
        <h1>④免許・資格</h1>
        ※最初に免許を書き、次に資格を記入してください。取得時から、資格の名称が変わっている場合は、取得時の資格名を記入してください。        <!-- Content Information Start -->
        <div class="contents-explain" style="padding-top:0;padding-bottom:0;">
          <div v-for="error in errors" :key="error">
            <span style="color:red;font-weight:bold;">{{error}}</span>
          </div>
        </div>
        <!-- Content Information End -->
          <table style="width:100%;border-spacing: 0px 5px;font-size:0.8em;">
            <thead>
            <tr>
              <th><label>年(西暦)：</label></th>
              <th></th>
              <th></th>
              <th></th>
              <th><label>免許・資格：</label></th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="menkyosikaku in indata.menkyosikakus" :key="menkyosikaku.id">
                <td style="width:80px;vertical-align:top;">
                  <select class="form-control" v-model="menkyosikaku.year">
                    <option v-for="w in dateyears" :key="w.id">{{w.label}}</option>
                  </select>
                </td>
                <td style="width:20px">
                  <span>年</span>
                </td>
                <td style="width:60px;vertical-align:top;">
                  <select class="form-control" v-model="menkyosikaku.month">
                    <option v-for="w in datemonths" :key="w.id">{{w.label}}</option>
                  </select>
                </td>
                <td style="width:20px;">
                  <span>月</span>
                </td>
                <td>
                  <input class="form-control" type="text" v-model="menkyosikaku.content" style="width:100%;">
                </td>
              </tr>
            </tbody>
          </table>
        <div class="btn-pagenav">
          <button 
              v-on:click="openPreview" 
              class="btn-preview">プレビュー</button>
        </div>
      </div>
      <div class="contents-form" v-if="page==5">
        <h1>⑤志望動機</h1>
          特技や好きな学科など、ご自身のアピールポイントを記入してください。
        <!-- Content Information Start -->
        <div class="contents-explain">
          <div v-for="error in errors" :key="error">
            <span style="color:red;font-weight:bold;">{{error}}</span>
          </div>
        </div>
        <!-- Content Information End -->
        <div class="form-group">
          <label>志望動機：</label>
          <textarea class="form-control" type="text" v-model="indata.sibodoki" style="width:100%;height:200px;font-size:14pt;"></textarea>
        </div>
        <div class="btn-pagenav">
          <button 
              v-on:click="openPreview" 
              class="btn-preview">プレビュー</button>
        </div>
      </div>
      <!--  6.本人希望欄 -->
      <div class="contents-form" v-if="page==6">
        <h1>⑥本人希望欄</h1>
          給与・職種・勤務時間・勤務地などのご希望を記入してください。
        <!-- Content Information Start -->
        <div class="contents-explain">
          <div v-for="error in errors" :key="error">
            <span style="color:red;font-weight:bold;">{{error}}</span>
          </div>
        </div>
        <!-- Content Information End -->
        <div class="form-group">
          <label>本人希望欄：</label>
          <textarea class="form-control" v-model="indata.honninkiboran" style="width:100%;height:200px;font-size:14pt;"></textarea>
        </div>
        <div class="btn-pagenav">
          <button 
              v-on:click="openPreview" 
              class="btn-preview">プレビュー</button>
        </div>
      </div>
      <!--  7.証明写真 -->
      <div class="contents-form" v-if="page==7">
        <h1>⑦証明写真</h1>
          使用する写真について
          <ul>
            <li>● 撮影から3ヶ月以内のものを使用してください。</li>
            <li>● 本人とわかる、単身胸から上の画像をしようしてください。</li>
            <li>● 縦36mm~40mm / 横24mm~30mmのサイズで撮影またはトリミングします。</li>
            <li>● 写真の背景はブルー（水色）または白を選びましょう。</li>
          </ul>
        <!-- Content Information Start -->
        <div class="contents-explain">
          <div v-for="error in errors" :key="error">
            <span style="color:red;font-weight:bold;">{{error}}</span>
          </div>
        </div>
        <!-- Content Information End -->
        <div class="form-group" style="text-align:center;">
          <img :src="indata.myphoto.bindata" width="120px" style="width;120px;">
        </div>
        <div :class="classesDragArea" @dragover.prevent="onArea" 
          @drop.prevent="dropFile" @dragleave.prevent="offArea" @dragend.prevent="offArea" style="text-align:center;">
          <label class="drag-label drop-area">ファイルを選択
            <input type="file" ref="file" id="file" mulitple="multiple" @change="setImage"/>
          </label>
        </div>
        <div class="btn-pagenav">
          <button 
              v-on:click="openPreview" 
              class="btn-preview">プレビュー</button>
        </div>
      </div>
    </div>
    <!-- ボタン群 -->
    <div class="btn-pagenav">
      <div class="">
          <button
              class="btn-next"
              type="button"
              v-if="page<7"
              @click="next">次へ</button>
          <button
              class="btn-send"
              type="button"
              v-if="page==7"
              @click="checkPreview">送信</button>
          <button
              class="btn-previous"
              type="button"
              v-if="page>1"
              @click="prev">戻る</button>
      </div>
    </div>
  </div>
</template>

<script>
var API_TOKEN = process.env.VUE_APP_API_TOKEN
var API_BASE_URL = process.env.VUE_APP_API_BASE_URL

//import jsPDF from 'jspdf'
import axios from 'axios'
import FormData from 'form-data'
//import qs from 'qs'
//import pdfMake from 'pdfmake/build/pdfmake';
//import pdfFonts from 'pdfmake/build/vfs_fonts'
//import htmlToPdfmake from 'html-to-pdfmake'
//pdfMake.vfs = pdfFonts.pdfMake.vfs;
//pdfMake.fonts = {
//  ipa: {
//    normal: "ipagp.ttf",
//    bold: "ipagp.ttf"
//  }
//};

import Preview from '../components/Preview.vue'
import moment from 'moment'
var m = new moment()

export default {
  name: 'Content',
  components: {
    Preview,
  },
  computed: {
      isError: function () {
          return !!this.error !== ''
      },
      classesDragArea () {
          return {
              'drag-on': this.inArea
          }
      }
  },
  data() {
    const dateyears = [];
    const datemonths = [];
    const datedays = [];
    const timehours = [];
    const timeminutes = [];
    for (let i=1960; i<= m.format('YYYY'); i++ ) {
      dateyears.push({
        id: ('0000' + i).slice(-4),
        label: ('0000' + i).slice(-4)
      });
    }
    for (let i=1; i<=12; i++) {
      datemonths.push({
        id: ('00' + i).slice(-2),
        label: ('00' + i).slice(-2)
      });
    }
    for (let i=1; i<=31; i++) {
      datedays.push({
        id: ('00' + i).slice(-2),
        label: ('00' + i).slice(-2)
      });
    }
    for (let i=0; i<=23; i++) {
      timehours.push({
        id: ('00' + i).slice(-2),
        label: ('00' + i).slice(-2)
      });
    }
    for (let i=0; i<=59; i++) {
      timeminutes.push({
        id: ('00' + i).slice(-2),
        label: ('00' + i).slice(-2)
      });
    }
    return {
      errors: [],
      mydata: '',
      dateyears,
      datemonths,
      datedays,
      timehours,
      timeminutes,
      showPreview: false,
      sendingFlag: false,
      checkPreviewFlag: false,
      page: 1,
      indata: {
        fname: '',
        lname: '',
        fnamekana: '',
        lnamekana: '',
        sex: '男',
        birthdayyear: (Number(m.format('YYYY')) -20).toString(),
        birthdaymonth: '01',
        birthdayday: '01',
        age: (Number(m.format('YYYY')) - Number(m.add(-20, 'years').format('YYYY'))),
        huyonin: '',
        haigusyaumu: '無',
        haigusyahuyogimu: '無',
        tukintimehour: '00',
        tukintimeminute: '00',
        gen: {
          zipcode: '',
          prefname: '',
          address: '',
          address2: '',
          prefnamekana: '',
          addresskana: '',
          addresskana2: '',
          tel: '',
          email: '',
        },
        renraku: {
          zipcode: '',
          prefname: '',
          address: '',
          address2: '',
          prefnamekana: '',
          addresskana: '',
          addresskana2: '',
          tel: '',
          email: '',
        },
        gakusyokus: [
          {id: 1,year: '',month: '',content: ''},
          {id: 2,year: '',month: '',content: ''},
          {id: 3,year: '',month: '',content: ''},
          {id: 4,year: '',month: '',content: ''},
          {id: 5,year: '',month: '',content: ''},
          {id: 6,year: '',month: '',content: ''}
        ],
        menkyosikakus: [
          {id: 1,year: '',month: '',content: ''},
          {id: 2,year: '',month: '',content: ''},
          {id: 3,year: '',month: '',content: ''},
          {id: 4,year: '',month: '',content: ''},
          {id: 5,year: '',month: '',content: ''},
          {id: 6,year: '',month: '',content: ''}
        ],
        sibodoki: '',
        honninkiboran: '',
        myphoto: {
          name: '',
          type: '',
          bindata: '',
        }
      }
    }
  },
  methods: {
    // ■次画面
    next() {
      if (this.checkForm(this.page)) {
        this.page++;
      }
      scrollTo(0, 0);
    },
    // ■前画面
    prev() {
      this.page--;
      scrollTo(0, 0);
    },
    // ■年齢計算
    calcAge() {
      let age =  (Number(moment().format('YYYY')) - Number(moment(this.indata.birthdayyear + '-' + this.indata.birthdaymonth + '-' + this.indata.birthdayday).format('YYYY')));
      this.indata.age = age
    },
    //■ エラーチェック
    checkForm: function (page) {
      this.errors = [];
      if (page == 1) {
        if ((!this.indata.fname) || (!this.indata.lname)) {
          this.errors.push("氏名を入力してください。");
        }
      } else if (page == 2) {
        if ((!this.indata.gen.tel) && (!this.indata.gen.email) && (!this.indata.renraku.tel) && (!this.indata.renraku.email)) {
          this.errors.push('現住所、連絡先の電話番号又はメールを入力してください。');
        } else if ((this.indata.gen.email.length > 0) && (!this.validEmail(this.indata.gen.email))) {
          this.errors.push('現住所メールの書式が正しくありません。');
        } else if ((this.indata.renraku.email.length > 0) && (!this.validEmail(this.indata.renraku.email))) {
          this.errors.push('連絡先メールの書式が正しくありません。');
        }
      } else if (page == 5) {
        if (!this.indata.sibodoki) {
          this.errors.push("志望動機を入力してください。");
        }
      } else if (page == 7) {
        if (!this.indata.myphoto.name) {
          this.errors.push("証明写真を選択してください。");
        }
      }
      if (!this.errors.length) {
        return true
      }
      //e.preventDefault();
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    //■ 送信処理
    submit() {
      if (this.sendingFlag) {
        alert("送信処理中です。")
        return
      }
      if (!this.checkForm(7)) return;
      //if (!confirm('入力した履歴書を送信します。よろしいですか?')) return
      this.sendingFlag = true;
      let formData = new FormData();
      formData.append('apitoken', API_TOKEN)

      //// 変数部
      Object.entries(this.indata).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            console.log(value)
        } else {
          formData.append(key, value)
        }
      })
      //// 配列部
      ////// 現住所
      Object.entries(this.indata.gen).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v, i) => {
            console.log(i)
            formData.append(key + '[]', v)  // arrayデータを分割して入れ直す
          })
        } else {
          formData.append('gen[' + key + ']', value)
        }
      })
      ////// 連絡先
      Object.entries(this.indata.renraku).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v, i) => {
            console.log(i)
            formData.append(key + '[]', v)  // arrayデータを分割して入れ直す
          })
        } else {
          formData.append('renraku[' + key + ']', value)
        }
      })
      ////// 学歴・職歴
      for(let ix=0;ix<this.indata.gakusyokus.length;ix++) {
        Object.entries(this.indata.gakusyokus[ix]).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v, i) => {
              console.log(i)
              formData.append(key + '[]', v)  // arrayデータを分割して入れ直す
            })
          } else {
            formData.append('gakusyokus[' + ix + '][' + key + ']', value)
          }
        })
      }
      ////// 免許・資格
      for(let ix=0;ix<this.indata.menkyosikakus.length;ix++) {
        Object.entries(this.indata.menkyosikakus[ix]).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v, i) => {
              console.log(i)
              formData.append(key + '[]', v)  // arrayデータを分割して入れ直す
            })
          } else {
            formData.append('menkyosikakus[' + ix + '][' + key + ']', value)
          }
        })
      }
      ////// 証明写真
      Object.entries(this.indata.myphoto).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v, i) => {
            console.log(i)
            formData.append(key + '[]', v)  // arrayデータを分割して入れ直す
          })
        } else {
          formData.append('myphoto[' + key + ']', value)
        }
      })
      var file = document.getElementById("file")
      formData.append("facefile", file.files[0]);

      let config = {
        method: 'post',
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
      let url = API_BASE_URL + 'index.php'
      axios.post(url, formData, config)
      .then(res => {
        // alert(res.data.status.message);
        console.log(res.data.status.message);
        this.sendingFlag = false;
        this.$router.push('/thanks');
      }).catch(error => {
        console.log(error);
        this.sendingFlag = false;
      });
    },
    navigationCss(targetPage) {
        if(this.page === targetPage) {  // 現在ページの場合
            return ['text-center', 'text-white', 'bg-info'];
        }
        return ['text-center', 'text-secondary'];
    },
    // 画像ファイル操作関連
    setImage(e) {
      console.log(e);
      this.errors = [];
      const files = this.$refs.file;
      const fileImg = files.files[0];
      if (fileImg.type.startsWith("image/")) {
       this.indata.myphoto.bindata = window.URL.createObjectURL(fileImg);
        this.indata.myphoto.name = fileImg.name;
        this.indata.myphoto.type = fileImg.type;
      }
    },
    dropFile(e) {
        this.changeFile(e)
        this.offArea()
    },
    changeFile (e) {
        const files = e.target.files || e.dataTransfer.files

        if (this.validation(files[0])) {
            this.file = files[0]
        } else {
            this.file = {}
        }
    },
    resetFile () {
        const input = this.$refs.file;
        input.type = 'text'
        input.type = 'file'
        this.file = {}
        this.error = ''
    },
    validation (file) {
        if (!this.isAllowFileType(file.type)) {
            this.error = this.getErrorMessageType()
            return false
        }

        if (!this.isAllowFileSize(file.size)) {
            this.error = this.getErrorMessageSize()
            return false
        }

        this.error = ''
        return true
    },
    onArea  () { this.inArea = true  },
    offArea () { this.inArea = false },

    // プレビュー関連
    checkPreview : function() {
      console.log(this.$modal)
      this.checkPreviewFlag = true
       this.mydata = this.indata
       this.$modal.show('modalview');
    },
    // プレビュー関連
    openPreview : function() {
      console.log(this.$modal)
       this.mydata = this.indata
       this.$modal.show('modalview');
    },
    closePreview : function () {
      this.checkPreviewFlag = false
      this.$modal.hide('modalview');
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
/* ファイル操作関連 */
.drag-label {
    font-size: 12px;
    padding: 2px 3px;
    width:100%;
}
.drag-label:hover {
    cursor: pointer;
}
.drag-label input {
    display: none;
}
#file_name {
    font-size: 14px;
    margin-left: 20px;
}
.reset_file_ico {
    padding: 0 4px;
    font-size: 12px;
    border: 1px solid #c6c6c6;
    border-radius: 10px;
}
.reset_file_ico:hover {
    cursor: pointer;
    border-color: #5f6674;
}
#error {
    color: #d70035;
}
.drop-area {
    padding: 10px;
    text-align: center;
    border: 1px dashed #1f1a1a;
    background-color: #f9f9f9;
}
.drag-on {
    border: 2px dashed #bcbcbc;
    background-color: #fafdff;
}

/* フォーム関連 */
input[type="radio"] {
	width: +2em;
	height: +2em;
  margin-right: 2px;
}
.form-leftlabel {
  margin-top: 10px;
}
.form-addlabel {
  margin-right:16px;
  margin-top: 10px;
}
h2.subtitle {
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 18px;
  font-weight: 700;
}
.titledoc {
  line-height: 1.5em
}
.subdoc {
  color:#9FA0A0;
  line-height: 1.5em
}
.sublabel {
  color:#9FA0A0;
}

/* 折りたたみ関連 */
.acd-check{
  display: none;
}
.acd-label{
  display: block;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 18px;
  font-weight: 700;
  position: relative;
}
.acd-label:after{
    box-sizing: border-box;
    content: '\f105';
    display: block;
    font-family: "Font Awesome 5 Free";
    height: 52px;
    padding: 8px;
    position: absolute;
    left: 150px;
    top: 0px;
}
.acd-content{
    height: 0;
    opacity: 0;
    transition: .5s;
    visibility: hidden;
}
.acd-check:checked ~ .acd-content {
    height: 660px;
    opacity: 1;
    visibility: visible;
}
.acd-check:checked ~ .acd-label:after{
  content: '\107';
}
</style>
